import React, { memo } from 'react';
import { connect } from 'react-redux';
import action from '@flux/action';
import { SwitchBtn } from '@components';

const ShowDetailToggle = ({ changeUserPreference, userPreference }) => {
  // const { value, onChange, isLoading } = useHideProjectDetail();

  console.log(
    'userPreference.shouldShowDetail: ',
    userPreference.shouldShowDetail,
  );
  return (
    <div className="show-detail-switch-wrapper">
      <SwitchBtn
        onClick={(v) => changeUserPreference({ shouldShowDetail: v })}
        checked={userPreference.shouldShowDetail}
      />
      <span>Show Detail</span>
    </div>
  );
};

const mapStateToProps = ({ projects }) => ({
  userPreference: projects.userPreference,
});

const mapDispatchToProps = (dispatch) => ({
  changeUserPreference(userPreference) {
    dispatch(action.changeUserPreference(userPreference));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ShowDetailToggle));
